import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "/packages"
      }}>{`Lieblingsweinpaket`}</a>{` aussuchen und bestellen.
Lieferung erfolgt eine Woche vor der `}<a parentName="p" {...{
        "href": "/schedule"
      }}>{`Verkostung`}</a>{`.
Sie erhalten vier 0,75 l-Flaschen und passende Mini-Bottles (50 ml)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      